import { changeLocale } from '@/lang';
import { App } from 'vue';

export function localeDateFormat(date: string, locales?: Intl.LocalesArgument) {
  // requested by Hermann
  return date ? new Date(date).toLocaleString(!locales || locales === 'en' ? 'en-gb' : locales) : '';
}

export function containsStr(str?: string | null, substr?: string | null): boolean {
  if (str === substr) return true;
  if (str === undefined || str === null || substr === undefined || substr === null) return false;
  return str.toLowerCase()
    .includes(substr.toLowerCase());
}

export default {

  install: (app: App) => {

    console.info('[utils] install plugin');

    // inject globally available methods ------------

    /**
     * @returns {string} a parameter from an URL
     */
    app.config.globalProperties.$getUrlParam = (url: string | null, name: string): string | null => {
      if (!url) return '';
      const idx = url.indexOf('?');
      if (idx > -1) url = url.substring(idx);
      return new URLSearchParams(url).get(name);
    };

    /**
     * changes the locale
     */
    app.config.globalProperties.$changeLocale = changeLocale;

  },

};
